import { TaxEndpoints } from '@/modules/accounting/tax/api/taxEndpoints'

export const taxEndpoints = new TaxEndpoints('tax_fee')
